import React from "react"
import { useTranslation } from "react-i18next"

import { APP_NAME } from "@/utils/constants"

import CloseIcon from "@mui/icons-material/Close"
import { Alert, Collapse, IconButton } from "@mui/material"

interface DataFreshnessAlertProps {
  onClose: () => void
  open: boolean
}

export const DataFreshnessAlert: React.FC<DataFreshnessAlertProps> = ({
  onClose,
  open,
}) => {
  const { t } = useTranslation("common")

  return (
    <Collapse in={open} unmountOnExit sx={{ width: "100%" }}>
      <Alert
        action={
          <IconButton
            aria-label={t("button.close")}
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        severity="info"
      >
        {t("dataFreshness.message", { appName: APP_NAME })}
      </Alert>
    </Collapse>
  )
}
